import React, { FC } from 'react';

import Svg from './Svg';
import colors from '../../utils/colorConstants';

interface Props {
  width: string;
  height: string;
  strokeColor?: string;
  className?: string;
}

const Copy: FC<Props> = ({
  className,
  height = '1.5rem',
  strokeColor = colors['dusty-gray'],
  width = '1.5rem',
}) => (
  <Svg className={className} height={height} title="Copy icon" viewBox="0 0 24 24" width={width}>
    <path
      d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
      fill={strokeColor}
    />
  </Svg>
);

export default Copy;
